<section class="section-bg" style="margin-top: 130px;">
    <div class="container" data-aos="fade-up">
        <div class="row">
            <div class="col-lg-12">
                <h1 class="theme_color">
                    We are now creating site specific safety orientation videos for our clients! Watch our sample videos
                    below to see what could be included for you.
                </h1>                

                <div class="row">
                    <div class="col-md-6">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/fSKki3tLQLA" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-md-6">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/wTmh3smzj1w" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 text-center theme_color"><h3>English</h3></div>
                    <div class="col-md-6 text-center theme_color"><h3>Spanish</h3></div>
                </div>

                <p class="theme_color mediumFontSize" style="margin-top: 10px;">
                    We also provide customers with the option to order customized hard hat stickers. Using numbered
                    stickers will help you keep track of employees on your site.
                </p>                

                <p class="theme_color mediumFontSize">
                    To find out more information on either of these products we provide, email
                    <a href="mailto:customerservice@sficompliance.com">customerservice@sficompliance.com</a> or call at <strong>303-649-1304</strong>.
                </p>
            </div>
        </div>
    </div>
</section>